module.exports = __webpack_public_path__ + "img/优势.e04b444b.png";